export default __webpack_public_path__ + "static/media/1991.96322c25.png";